<template>
  <v-row>
    <v-col cols="12" xs="12" class="pa-0">
      <TablePlaylist :showTitle="true"></TablePlaylist>
    </v-col>
    <v-col cols="12" class="text-right" v-if="false">
      <v-btn @click="createItem()">Neu erstellen</v-btn>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import TablePlaylist from './../tables/TablePlaylist'

export default {
  name: 'Uploads',
  components: {TablePlaylist},
  data () {
    return {}
  },
  methods: {
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$api.createPlaylist({}, this.onPlayListCreated)
    },
    onPlayListCreated: function (newItem) {
      console.log('onPlayListCreated', newItem)
      this.$router.push('/Playlist/' + newItem.guid)
    }
  },
  mounted () {
    //Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>
